import { Input } from "antd";
import { cn } from "@/shared/lib/utils";

export function InputOTP({
  length = 6,
  value,
  onChange,
  disabled,
  containerClassName,
}: {
  length?: number;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  containerClassName?: string;
}) {
  return (
    <Input.OTP
      length={length}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={cn("flex items-center gap-2", containerClassName)}
      formatter={(str) => str.toUpperCase()}
    />
  );
}

export function InputOTPGroup({ children }: { children?: React.ReactNode }) {
  return <>{children}</>;
}
export function InputOTPSlot({ index }: { index: number }) {
  return null;
}